import { BusinessUnitProductItemSchema } from "./business-unit-product-item";
import { z } from "zod";

export const BusinessUnitItemSchema = z.object({
  Id: z.string(),
  Name: z.string(),
  ParentName: z.string().optional(),
  ParentId: z.string().optional(),
  Status: z.string().optional(),
  Account: z.string().optional(),
  Number: z.string().optional(),
  CountryId: z.string().optional(),
  CountryName: z.string().optional(),

  // Address fields
  Address: z.string().optional(),
  AddressCountry: z.string().optional(),
  AddressStateOrProvince: z.string().optional(),
  AddressCity: z.string().optional(),
  AddressLine1: z.string().optional(),
  AddressPostalCode: z.string().optional(),

  // Contact information
  Email: z.string().optional(),
  Phone: z.string().optional(),
  PrimaryContactId: z.string().optional(),
  PrimaryContactName: z.string().optional(),

  // Fuel Brand
  FuelBrandId: z.string().optional(),
  FuelBrandName: z.string().optional(),

  // Cash Register Brand and Model
  CashRegisterBrandId: z.string().optional(),
  CashRegisterBrandName: z.string().optional(),
  CashRegisterModelId: z.string().optional(),
  CashRegisterModelName: z.string().optional(),

  // Cash Register fields for the form
  Brand: z.string().optional(),
  Model: z.string().optional(),
  CrLogin: z.string().optional(),
  CrPassword: z.string().optional(),
  BullochId: z.string().optional(),
  AcumeraId: z.string().optional(),
  MakoId: z.string().optional(),

  // Validation flags
  ValidationLicense: z.boolean().optional(),
  ValidationHardware: z.boolean().optional(),
  ValidationSameProduct: z.boolean().optional(),

  PaystandId: z.string().optional(),

  Products: BusinessUnitProductItemSchema.array().optional(),
});

export type BusinessUnitItemType = z.infer<typeof BusinessUnitItemSchema>;
